import { render, staticRenderFns } from "./geofenceDetail.vue?vue&type=template&id=675b599b&scoped=true&"
import script from "./geofenceDetail.vue.js?vue&type=script&lang=js&"
export * from "./geofenceDetail.vue.js?vue&type=script&lang=js&"
import style0 from "./geofenceDetail.vue?vue&type=style&index=0&id=675b599b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "675b599b",
  null
  
)

export default component.exports